<!--
  课程管理 - 新增/编辑
-->
<template>
  <div class="SubWebPage" v-loading.fullscreen.lock="fullscreenLoading">


    <el-card class="box-card">
      <el-alert title="操作说明：选择左侧课目可拖拽至右侧单元格内，进行固定课设置。也可以将右侧单元格内的课目拖拽回左侧栏内。" type="warning" :closable="false">
      </el-alert>
    </el-card>



    <el-card class="box-card" :class="itemLabelBox">
      <div class="card-body">
        <div class="divSearchBox">
          <el-input placeholder="输入关键字进行过滤" v-model="txtSearch" class="input-with-select" @input="onSearchInput">
            <el-button slot="append" icon="el-icon-refresh-right" @click="onFilterText()"></el-button>
          </el-input>
        </div>
        <div class="divLabelBody">
          <draggable v-model="planData" :group="onGetLeftGroup()" ghostClass="ghost" chosenClass="chosen"
            filter=".forbid" animation="300" :move="onMoveLeft" @start="onStart" @end="onEndLeft" @add="onRightAdd">
            <transition-group class="boxGroup" :style="'width:'+itemWidth+'px;'">
              <div v-for="(item,index) in planData" :key="index+'left'" class="itemBox itemLeftBox">
                <div class="divNumberBox VerticalMid">
                  <span class="spNumber VerticalMid">{{item.surplus}}</span>
                </div>
                <div class="divMoreBox" v-if="!regNullArray(item.classes)" @click="onShowClass(item)">
                  <i class="el-icon-d-arrow-left" v-if="item.isShowClass"></i>
                  <i class="el-icon-d-arrow-right" v-else></i>
                </div>
                <div class="itemTitle">{{item.subject}}</div>
                <div class="itemInfo" v-if="!regNull(item.teacher)">
                  <span class="spTitle">教师</span>
                  <span class="spFonts">{{item.teacher}}</span>
                </div>
                <div class="itemInfo" v-if="!regNull(item.classroom)">
                  <span class="spTitle">场地</span>
                  <span class="spFonts">{{item.classroom}}</span>
                </div>
                <div class="itemInfo" v-if="item.isShowClass">
                  <span class="spFonts">{{onGetClassName(item.classes)}}</span>
                </div>
              </div>
            </transition-group>
          </draggable>
        </div>
      </div>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="card-header">
        <h3 class="card-title titleCont">
          <span class="spIcon"></span>
          固定课排课
        </h3>
        <div class="card-tools">
          <ul class="nav">
            <li class="nav-item">
              <el-select v-model="semesterId" placeholder="请选择学期" @change="onChangeSemester()">
                <el-option v-for="item in optSemester" :key="item.semesterId" :label="item.name"
                  :value="item.semesterId">
                </el-option>
              </el-select>
            </li>
          </ul>
        </div>
      </div>
      <div class="card-body">

        <table class="table table-bordered tableBox">
          <tr>
            <td width="9%">
              <div class="divTableTitleBox">
                <div class="divWeek">星期</div>
                <div class="divIndex">节次</div>
              </div>
            </td>
            <td class="divWeekName" :width="90/optWeekTitle.length+'%'" v-for="(item,index) in optWeekTitle"
              :key="index">
              {{optWeekName[item.dayOfWeek]}}
            </td>
          </tr>
          <tr v-for="(item,index) in itemData" :key="index">
            <td class="divTimesBox">{{item.sectionIndex}}</td>
            <td v-for="(list,indexTwo) in item.children" :key="indexTwo" class="tdSetBox">
              <div class="divNoArrange" v-if="onShowNo(list)">
                <div class="divName"><svg class="icon" aria-hidden="true">
                    <use xlink:href="#fax-exclamation-triangle-o"></use>
                  </svg>已设置不排课</div>
              </div>
              <draggable v-model="list.fix" :group="onGetGroup(list)" ghostClass="ghost" chosenClass="chosen"
                filter=".forbid" animation="300" :move="onMove" @clone="onStartRight(list,$event)" @end="onEndLeft"
                @add="onCreateCurriculum($event,list)" @choose="onRightChoose(list)" @unchoose="onRightUnchoose(list)">
                <transition-group :style="groupHeight">
                  <div v-for="(it,indexThi) in list.fix" :key="indexThi+'right'" class="itemBox">
                    <div class="itemTitle">{{it.subject}}</div>
                    <div class="itemInfo" v-if="!regNull(it.teacher)">
                      <span class="spTitle">教师</span>
                      <span class="spFonts">{{it.teacher}}</span>
                    </div>
                    <div class="itemInfo" v-if="!regNull(it.classroom)">
                      <span class="spTitle">场地</span>
                      <span class="spFonts">{{it.classroom}}</span>
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </td>
          </tr>
        </table>
      </div>
    </el-card>


  </div>
</template>

<script>
  import '@/assets/css/Admin.css';
  import draggable from 'vuedraggable';
  export default {
    components: {
      draggable
    },
    data() {
      return {
        // 加载动画
        fullscreenLoading: false,

        // 计划数组
        planData: [],
        allPlanData: [],
        //
        optSemester: [],
        semesterId: null,


        // tabs
        tabsIndex: '0',
        txtSearch: null,

        itemData: [],
        ScheduleData: [{
            monday: [],
            tuesday: [],
            wednesday: [],
            thursday: [],
            friday: [],
          },
          {
            monday: [],
            tuesday: [],
            wednesday: [],
            thursday: [],
            friday: [],
          },
          {
            monday: [],
            tuesday: [],
            wednesday: [],
            thursday: [],
            friday: [],
          },
          {
            monday: [],
            tuesday: [],
            wednesday: [],
            thursday: [],
            friday: [],
          },
          {
            monday: [],
            tuesday: [],
            wednesday: [],
            thursday: [],
            friday: [],
          },
          {
            monday: [],
            tuesday: [],
            wednesday: [],
            thursday: [],
            friday: [],
          },

        ],
        groupHeight: 'min-height:100px; display: block;',
        // 显示星期
        optWeekName: ['', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
        optWeekTitle: [],
        // 左侧
        leftGroup: {
          name: "itxst",
          put: true, //可以拖入
          pull: true,
        },
        // 表格拖动计划时记录表格CellID
        tdCellID: null,
        // 表格拖动计划时记录表格信息
        tdItemInfo: null,
        isShowClassType: false,
        itemWidth: 0,

        itemLabelBox: '',
      };
    },
    created() {
      let that = this;

      that.fullscreenLoading = true;
      ajaxGet(that, '/api/admin/semester', null, function(resSemester) {
        that.fullscreenLoading = false;
        that.optSemester = resSemester;
        let tpSemester = resSemester.find(item => item.isCurrent == true);
        if (!regNull(tpSemester)) {
          that.semesterId = tpSemester.semesterId;
        } else {
          that.semesterId = resSemester[0].semesterId;
        }


        that.onGetResetTable(that, null);
        onGetPlan(that);
      });

    },
    mounted() { //可以在这里面直接进行滚动条的获取
      let that = this;
      $(window).scroll(function() {
        if (document.documentElement.scrollTop > 130) {
          that.itemLabelBox = 'fixedBox';
        } else {
          that.itemLabelBox = null;
        }
      });

    },
    methods: {

      /**
       * @description 展示班级
       * @param {Object} objItem
       */
      onShowClass(objItem) {
        let that = this;
        if (objItem.isShowClass) {
          objItem.isShowClass = false;
        } else {
          objItem.isShowClass = true;
        }
      },
      /**
       * @description 获取班级名称
       * @param {Object} objItem
       */
      onGetClassName(objItem) {
        let that = this,
          tempName = '';
        if (!regNullArray(objItem)) {
          objItem.forEach((item) => {
            tempName += item.class + '、';
          });
        }
        return tempName.substring(0, tempName.length - 1);
      },
      /**
       * @param {Object} objItem
       */
      onRightAdd(objItem) {
        let that = this;
        if (!regNull(that.tdItemInfo)) {
          ajaxDeleteNoTip(that, '/api/admin/semesterfix/' + that.tdItemInfo.fix[objItem.oldIndex].fixId, null, function(
            resDel) {
            that.onGetResetTable(that, null);
            onGetPlan(that);
          });
        }
      },
      /**
       * @description
       * @param {Object} objItem
       */
      onSearchInput(objItem) {
        let that = this;
        if (regNull(objItem)) {
          that.planData = JSON.parse(JSON.stringify(that.allPlanData));
          that.itemWidth = that.allPlanData.length * 206;
        } else {
          that.planData = that.allPlanData.filter(item => item.subject.indexOf(objItem) != -1);
          setTimeout(function() {
            that.itemWidth = that.planData.length * 206;
            return false;
          }, 500);
        }
      },
      /**
       * @description 重置过滤
       */
      onFilterText() {
        let that = this;
        that.txtSearch = null;
        that.planData = JSON.parse(JSON.stringify(that.allPlanData));
        that.itemWidth = that.allPlanData.length * 206;
      },
      /**
       * @description
       * @param {Object} objItem
       */
      onRightChoose(objItem) {
        let that = this;
        that.tdItemInfo = objItem;
        that.tdCellID = objItem.cellId;
      },
      onRightUnchoose(objItem) {
        let that = this;
        // that.tdItemInfo = null;
        that.tdCellID = null;
      },
      /**
       * @description 左侧拖动结束后事件
       * @param {Object} objItem
       */
      onEndLeft(objItem) {
        let that = this;
        that.onGetResetTable(that, null);
      },
      /**
       * @description 是否显示 能否排课
       * @param {Object} objItem
       */
      onShowNo(objItem) {
        let that = this;
        if (objItem.cellId != that.tdCellID) {
          if (!objItem.forbidden) {
            if (objItem.planForbidden || objItem.classForbidden || objItem.teacherForbidden || objItem.roomForbidden ||
              objItem.isFix) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        }
        return false;
      },
      /**
       * @description 计算右侧拖入规则
       * @param {Object} objItem
       */
      onGetGroup(objItem) {
        let that = this;
        let params = {
          name: "itxst",
          put: true, //可以拖入
          pull: true, //可以拖出
        }
        if (objItem.cellId != that.tdCellID) {
          if (!objItem.forbidden) {
            if (objItem.planForbidden || objItem.classForbidden || objItem.teacherForbidden || objItem.roomForbidden ||
              objItem.isFix) {
              params.put = false;
            } else {
              params.put = true;
            }
          } else {
            params.put = false;
          }
        }

        return params;
      },
      onGetLeftGroup(objItem) {
        let params = {
          name: "itxst",
          put: true, //可以拖入
          pull: true, //可以拖出
        }
        // if (objItem.surplus > 0) {
        //   params.pull = true;
        // }
        return params;
      },
      /**
       * @description 拖动时的效果
       * @param {Object} objItem
       */
      onStart(objItem) {
        let that = this;
        that.tdCellID = null;
        that.tdItemInfo = null;
        that.onGetResetTable(that, that.planData[objItem.oldIndex].planId)
      },
      /**
       * @description 右侧拖动事件
       * @param {Object} objItem
       */
      onStartRight(objData, objItem) {
        let that = this;
        that.onGetResetTable(that, objData.fix[objItem.oldIndex].planId);
      },
      /**
       * @description 移入课表时触发事件
       * @param {Object} objItem
       * @param {Object} objArray
       */
      onCreateCurriculum(objItem, objArray) {
        let that = this,
          tpParams = {
            cellId: objArray.cellId,
            planId: objArray.fix[objItem.newIndex].planId
          }

        if (!regNull(objArray.fix[objItem.newIndex].fixId)) {
          // 先删除
          ajaxDeleteNoTip(that, '/api/admin/semesterfix/' + objArray.fix[objItem.newIndex].fixId, null, function(
            resDel) {
            ajaxPostNoTip(that, '/api/admin/semesterfix', tpParams, function(res) {
              that.onGetResetTable(that, null);
              onGetPlan(that);
            });
          });

        } else {
          ajaxPostNoTip(that, '/api/admin/semesterfix', tpParams, function(res) {
            that.onGetResetTable(that, null);
            onGetPlan(that);
          });
        }
      },
      /**
       * @description 去除重复值
       * @param {Object} arr
       */
      onArrUnique(arr) {
        const res = new Map();
        return arr.filter((arr) => !res.has(arr.sectionIndex) && res.set(arr.sectionIndex, 1));
      },
      /**
       * @description move回调方法
       * @param {Object} e
       * @param {Object} originalEvent
       */
      onMove(e, originalEvent) {
        let that = this;
        // if (e.relatedContext.element.sectionsPerWeek == 0) return false;
        return true;
      },
      onMoveLeft(e, originalEvent) {
        let that = this;
        if (e.draggedContext.element.surplus == 0) return false;
        return true;
      },
      /**
       * @param {Object} that
       */
      onGetResetTable(that, objID) {
        let apiUrl = null;
        if (regNull(objID)) {
          apiUrl = '/api/admin/semestercell/fix/' + that.semesterId;
        } else {
          apiUrl = '/api/admin/semestercell/fix/' + that.semesterId + '?planId=' + objID;
        }
        ajaxGet(that, apiUrl, null, function(resData) {
          that.itemData = [];
          const res = new Map();
          let weekTitle = resData.filter((arr) => !res.has(arr.dayOfWeek) && res.set(arr.dayOfWeek, 1));
          that.optWeekTitle = weekTitle.sort((a, b) => a.dayOfWeek - b.dayOfWeek);
          let temp = that.onArrUnique(resData);
          temp = temp.sort((a, b) => a.sectionIndex - b.sectionIndex);
          temp.forEach((item) => {
            let tpData = resData.filter((list) => {
              if (list.sectionIndex == item.sectionIndex) {
                list.dayOfWeek = setInt(list.dayOfWeek);
                return list;
              }
            });
            tpData = tpData.sort((a, b) => a.dayOfWeek - b.dayOfWeek);
            that.itemData.push({
              sectionIndex: item.sectionIndex,
              children: tpData
            });
          });
        });
      },
      //切换学期
      onChangeSemester() {
        let that = this;
        that.txtSearch = null;
        that.onGetResetTable(that, null);
        onGetPlan(that);
      }
    },
  };

  /**
   * @description 获取教学计划
   * @param {Object} that
   */
  function onGetPlan(that) {
    ajaxGet(that, '/api/admin/semesterplan/fixplan?semesterId=' + that.semesterId, null, function(resPlan) {
      that.planData = [];
      that.allPlanData = [];
      that.itemWidth = 0;
      // that.txtSearch = null;
      resPlan.forEach((item) => {
        if (item.surplus > 0) {
          item.isShowClass = false;
          that.itemWidth += 206;
          that.planData.push(item);
          that.allPlanData.push(item);
          if (!regNull(that.txtSearch)) {
            that.onSearchInput(that.txtSearch);
          }
        }
      });
    });
  }
</script>

<style scoped="scoped" lang="less">
  .fixedBox {
    position: fixed;
    right: 20px;
    top: 10px;
    z-index: 999;
    left: 230px;
  }


  .itemBox {
    margin-bottom: 10px;
    cursor: pointer;

    &:last-child {
      margin-bottom: 0;
    }

    .itemTitle {
      text-align: center;
      border: 1px solid #409eff;
      background-color: #409eff;
      color: #FFFFFF;
      padding-top: 5px;
      padding-bottom: 5px;
      font-size: 12px;
      padding-left: 15px;
      padding-right: 15px;
    }

    .itemInfo {
      font-size: 12px;
      text-align: center;
      padding-top: 5px;
      padding-bottom: 5px;
      border-bottom: 1px solid #DCDFE6;
      border-left: 1px solid #DCDFE6;
      border-right: 1px solid #DCDFE6;
      background-color: #FFFFFF;

      .spTitle {
        padding-right: 2px;
        color: #909399;
      }

      .spFonts {
        padding-left: 2px;
        color: #303133;
      }
    }
  }

  .divLabelBody {
    overflow-x: auto;
    width: 100%;
    padding-bottom: 30px;
  }

  .boxGroup {
    width: 80000px;
    display: block;

    .itemLeftBox {
      float: left;
      position: relative;
      width: 200px;
      margin-right: 5px;
      margin-bottom: 0;

      .divNumberBox {
        position: absolute;
        top: 4px;
        left: 4px;

        .spNumber {
          border: 2px solid #409eff;
          color: #409eff;
          border-radius: 5px;
          font-size: 12px;
          background-color: #FFFFFF;
          width: 25px;
          height: 25px;
        }
      }

      .divMoreBox {
        position: absolute;
        top: 7px;
        right: 7px;
        color: #FFFFFF;
        font-size: 12px;
        cursor: pointer;
        transform: rotate(90deg);
        -ms-transform: rotate(90deg);
        /* IE 9 */
        -moz-transform: rotate(90deg);
        /* Firefox */
        -webkit-transform: rotate(90deg);
        /* Safari 和 Chrome */
        -o-transform: rotate(90deg);
        /* Opera */
      }
    }

  }

  .tableBox {

    td {
      border: 2px solid #aaa;
    }

    .tdSetBox {
      position: relative;
    }

    .divNoArrange {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-flow: wrap;
      color: #303133;
      background-color: #EBEEF5;

      .icon {
        height: 30px;
        width: 100%;
      }

      .divName {
        font-size: 18px;
        color: #303133;
      }
    }

    .divTableTitleBox {

      background-image: linear-gradient(to bottom left, #a0cfff 50%, #aaa, #a0cfff 51%);
      height: 60px;
      position: relative;
      margin: -0.75rem;

      .divWeek {
        position: absolute;
        top: 5px;
        right: 5px;
        color: #000000;
      }

      .divIndex {
        position: absolute;
        bottom: 5px;
        left: 5px;
        color: #000000;
      }
    }


    .divWeekName {
      background-color: #a0cfff;
      text-align: center;
      font-size: 18px;
      padding-top: 5px;
      padding-bottom: 5px;
      vertical-align: middle;
      color: #000000;
    }

    .divTimesBox {
      height: 60px;
      vertical-align: middle;
      text-align: center;
      background-color: #a0cfff;
      color: #000000;
    }

  }

  .itemTip {
    margin-bottom: 5px;

  }

  .tdIndex {
    vertical-align: middle;
  }

  .tdCont {
    min-height: 300px;
  }

  .chosen {
    background-color: #ecf5ff !important;
    border-color: #b3d8ff;

    .spBook {
      color: #409eff !important;
    }
  }

  .ghost {
    border-color: #b3d8ff;
    background-color: #ecf5ff;

    .spBook {
      color: #409eff !important;
    }
  }


  .listBox {
    border: 1px solid #DCDFE6;
    border-radius: 5px;
    padding: 5px 10px;
    margin-bottom: 10px;
    position: relative;

    .spBook {
      font-size: 14px;
      color: #409eff;
      width: 100%;
    }

    .spLabel {
      font-size: 12px;
    }

    .divNumber {
      position: absolute;
      top: 4px;
      right: 6px;
      bottom: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      vertical-align: middle;

      .spNumber {
        border-radius: 5px;
        background-color: #409eff;
        color: #FFFFFF;
        font-size: 12px;
        width: 30px;
        height: 20px;
      }
    }
  }

  .noNumber {
    background-color: #F2F6FC;

    .spBook {
      color: #909399;
    }

    .divNumber {
      .spNumber {
        background-color: #DCDFE6;
      }
    }
  }



  .divSearchBox {
    margin-bottom: 10px;
  }

  .tabsHeader {
    margin: -18px -20px;
    background-color: #f5f7fa;
  }

  .divWeekName {
    background-color: #F2F6FC;
    text-align: center;
    font-size: 18px;
    padding-top: 5px;
    padding-bottom: 5px;
  }







  label {
    margin-bottom: 0;
  }

  .spIcon {
    width: 5px;
    height: 20px;
    border-radius: 5px;
    background-image: linear-gradient(#4545FF, #2D8EFF);
  }
</style>


<style lang="less">
  .tabsHeader {
    .el-tabs__header {
      margin: 0;
      margin-bottom: -1px;
    }

    .el-tabs--card>.el-tabs__header .el-tabs__nav {
      border: none;
    }

    .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
      background-color: #FFFFFF;
    }
  }
</style>
